/**
 * Enum for operation types
 */ export var OperationType = /*#__PURE__*/ function(OperationType) {
    /** Copy plan operation */ OperationType["CopyPlan"] = "copyPlan";
    /** Create Plan from Template operation */ OperationType["CreatePlanFromTemplate"] = "createPlanFromTemplate";
    /** Status Report operation */ OperationType["GenerateStatusReport"] = "generateStatusReport";
    /** Sydney (Planner agent) status report operation */ OperationType["SydneyStatusReport"] = "sydneyStatusReport";
    /** Premium Plan Task Suggestion operation */ OperationType["PremiumPlanTaskSuggestion"] = "premiumPlanTaskSuggestion";
    return OperationType;
}({});
/**
 * Version of the status report.
 */ export var StatusReportVersion = /*#__PURE__*/ function(StatusReportVersion) {
    /** Report generated by Mars */ StatusReportVersion["V1"] = "v1";
    /** Report generated by Sydney (Planner agent) */ StatusReportVersion["V2"] = "v2";
    return StatusReportVersion;
}({});
/**
 * Status of an operation
 */ export var OperationStatus = /*#__PURE__*/ function(OperationStatus) {
    /** The operation completed successfully */ OperationStatus["CompletedSuccessfully"] = "completedSuccessfully";
    /** The operation completed with errors */ OperationStatus["CompletedWithErrors"] = "completedWithErrors";
    /** The operation is running */ OperationStatus["Running"] = "running";
    return OperationStatus;
}({});
/**
 * Options for copying a plan
 */ export var CopyPlanOptions = /*#__PURE__*/ function(CopyPlanOptions) {
    CopyPlanOptions["CopyTaskReferences"] = "copyTaskReferences";
    CopyPlanOptions["CopyTaskChecklists"] = "copyTaskChecklists";
    CopyPlanOptions["CopyTaskDates"] = "copyTaskDates";
    CopyPlanOptions["CopyTaskDescriptions"] = "copyTaskDescriptions";
    CopyPlanOptions["CopyPlanAndTaskCategories"] = "copyPlanAndTaskCategories";
    CopyPlanOptions["CopyTaskPriorities"] = "copyTaskPriorities";
    CopyPlanOptions["CopyGoals"] = "copyGoals";
    CopyPlanOptions["CopyTaskRecurrence"] = "copyTaskRecurrence";
    CopyPlanOptions["UnknownFutureValue"] = "unknownFutureValue";
    return CopyPlanOptions;
}({});
/**
 * The status of the copy plan operation (Used in Tracking)
 */ export var CopyPlanOperationStatus = /*#__PURE__*/ function(CopyPlanOperationStatus) {
    /** The operation completed successfully */ CopyPlanOperationStatus["CompletedSuccessfully"] = "completedSuccessfully";
    /** The operation is running */ CopyPlanOperationStatus["Running"] = "running";
    /** The operation completed with errors */ CopyPlanOperationStatus["CompletedWithErrors"] = "completedWithErrors";
    /**
     * The status exists as a future value the service is sending that the client doesn't understand
     * https://learn.microsoft.com/en-us/graph/best-practices-concept#handling-future-members-in-evolvable-enumerations
     */ CopyPlanOperationStatus["UnknownFutureValue"] = "unknownFutureValue";
    return CopyPlanOperationStatus;
}({});
/**
 * The type of mutation operation being performed on an entity.
 */ export var EntityOperationType = /*#__PURE__*/ function(EntityOperationType) {
    /** Creating a new entity */ EntityOperationType["Create"] = "create";
    /** Updating an existing entity (properties, collections, or relationships) */ EntityOperationType["Update"] = "update";
    /** Deleting an entity. The soft/hard distinction is captured in baseline & baselineChain. */ EntityOperationType["Delete"] = "delete";
    /** Restoring a previously deleted entity. */ EntityOperationType["UnDelete"] = "undelete";
    return EntityOperationType;
}({});
